/* eslint-disable react/no-array-index-key */
import { AdvancedInputProps } from '../../types/global';
import Tooltip from '../toolTip';

function AdvancedInput({
  type, label, id, tooltip, options = [], ...otherProps
}: Readonly<AdvancedInputProps>) {
  switch (type) {
    case 'slider':
      return (
        <div>
          <label htmlFor={id}>{label}</label>
          <input type="range" id={id} {...otherProps} />
        </div>
      );
    case 'dropdown':
      return (
        <label htmlFor={id} className="flex flex-col p-2 justify-between font-thin w-full">
          <span className="text-sm">{label}</span>
          <select id={id} {...otherProps} name={id} className="flex-1 p-1 rounded-md align-middle bg-slate-50 border border-pipgrey-light text-piptext-body">
            <option value="" disabled>Please select option</option>
            {options.map((option, index) => (
              <option key={`${option}-${index}`} value={option}>{option}</option>
            ))}
          </select>
        </label>
      );

    case 'radio':
      return (
        <fieldset>
          <legend>{label}</legend>
          {options.map((option, index) => (
            <label htmlFor={label} key={`${option}-${index}`}>
              <div>
                <input type="radio" id={`${option}-${index}`} name={id} value={option} />
                {option}
              </div>
            </label>
          ))}
        </fieldset>
      );

    case 'monthyear':
      return (
        <div className="flex flex-col p-2 justify-between font-thin w-full lg:w-1/2">
          <label htmlFor={id} className="flex-none mr-2 p-1 text-sm">
            {label}
          </label>
          <input type="month" id={id} className="flex-1 p-1 rounded-md align-middle bg-slate-50 border border-pipgrey-light text-piptext-body " {...otherProps} />
        </div>
      );

    case 'checkbox':
      return (
        <label htmlFor={id} className="flex items-center gap-2 text-sm font-thin w-full">
          <input
            type="checkbox"
            id={id}
            {...otherProps}
          />
          <span>{label}</span>
          {tooltip ? <Tooltip label={label} text={tooltip} /> : null}
        </label>
      );

    case 'file':
      return (
        <div className="flex flex-col p-2 justify-between font-thin w-full">
          <label htmlFor={id} className="flex flex-row gap-2 items-center mr-2 p-1 text-sm">
            {label}
            {tooltip ? <Tooltip label={label} text={tooltip} /> : null}
          </label>
          <input
            type="file"
            id={id}
            accept=".xml,application/xml,text/xml"
            className="flex-1 p-1 text-sm text-piptext-body"
            {...otherProps}
          />
        </div>
      );
    default:
      return (
        <div className="flex flex-col p-2 justify-between font-thin w-full lg:w-1/2">
          <label htmlFor={id} className="flex flex-row gap-2 items-center mr-2 p-1 text-sm">
            {label}
            {tooltip ? <Tooltip label={label} text={tooltip} /> : null}
          </label>
          <input type="text" id={id} className="flex-1 p-1 rounded-md align-middle bg-slate-50 border border-pipgrey-light text-piptext-body " {...otherProps} />
        </div>
      );
  }
}

export default AdvancedInput;
